// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qz","text":"qA","subText":"qB","toggleContainer":"qC","checked":"qD"};